var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',[_c('a',{attrs:{"href":"https://open.kakao.com/o/gNPtdUZ"}},[_vm._v("오픈채팅 피드백")])])])}]

export { render, staticRenderFns }